module.exports = __webpack_public_path__ + "img/pix_icon.1a68e892.svg";